// =============================================================================
// Normascan — Plateforme d'analyse normative par IA
// Copyright (c) 2026-2027 Evalens SAS — Tous droits réservés
// Marque Normascan déposée INPI n°5242986 (classes 9 et 42)
// Site : https://app.normascan.fr
// =============================================================================
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initTheme } from './components/PreferencesModal';
import { installerFetchDeSession } from './lib/session';
// AVANT le premier rendu : tout appel à l'API passe par là (cookie de session,
// jeton anti-CSRF, renouvellement du jeton — cf lib/session.js).
installerFetchDeSession();
initTheme();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);
